import { sk } from 'date-fns/locale'

export default defineAppConfig({
  platformName: 'porovnajto',
  locale: sk,
  currency: 'EUR',
  blog: {
    url: '/magazin',
    swiperName: 'Súvisiace články',
    swiperSeeAll: 'Zobraziť všetky články',
    seeAll: 'Všetky články',
    share: 'Zdieľať článok',
    moreFromAutor: 'Viac článkov autora',
    fetchMore: 'Načítať ďalšie',
    readArticle: 'Čítať článok',
    allArticles: 'Všetky články',
    mostReadArticles: 'Najčítanejšie',
    topArticles: 'Top články',
    articleLength: 'Dĺžka čítania',
    articleContent: 'Obsah článku',
    show: 'Zobraziť',
    more: 'viac',
    less: 'menej',
    topics: 'tém',
    documentPatterns: 'Vzory dokumentov',
    moreInfo: 'Viac informácií',
    download: 'Stiahnuť',
    category: 'Kategória',
  },
})
